import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { SHADOW_OFFSET } from './coverHelpers'

interface Props {
  size: string
  image: string | null
  shadow: string
  onMediaClick?: () => void
  placeholder?: ReactNode
}

export const MediaGroup = ({ size, image, shadow, onMediaClick, placeholder }: Props) => (
  <div className="relative shrink-0" style={{ width: size, height: size }}>
    <div
      className="absolute rounded-xl"
      style={{
        backgroundColor: shadow,
        inset: 0,
        transform: `translate(-${SHADOW_OFFSET * 100}%, ${SHADOW_OFFSET * 100}%)`,
      }}
    />
    <div
      onClick={onMediaClick}
      className={cn(
        'absolute inset-0 rounded-xl bg-white overflow-hidden flex items-center justify-center',
        onMediaClick && 'cursor-pointer',
      )}
      style={{ transform: 'rotate(1deg)' }}
    >
      {image ? (
        <img src={image} alt="" className="w-full h-full object-cover" />
      ) : placeholder ? (
        placeholder
      ) : (
        <div className="w-full h-full bg-muted" />
      )}
    </div>
  </div>
)
